import React from "react";
import { ISuccessHeaderProps } from "./SuccessHeader.types";
import { getFlowDataDirect, setFlowDataDirect } from "@adaptis/flow-components";
import "./SuccessHeader.scss";
import { pushDataToGTM } from "../../KnoseAPI/Lib/Utils";
import { getGTMQuoteData } from "../../util/helper-functions";

export default function SuccessHeader(props: ISuccessHeaderProps) {
  // The policies for a1, a2 & a3 are now set up.
  let allPetNames = getFlowDataDirect("totalAmounts.allPetNames");
  let petQty = getFlowDataDirect("petQty");

  let message = "";

  if (petQty === 1) {
    message = `The policy for ${allPetNames} is now set up.`;
  } else {
    message = `The policies for ${allPetNames} are now set up.`;
  }

  React.useEffect(() => {
    pushDataToGTM("Payment Completed", getGTMQuoteData("Payment Completed"));
    setFlowDataDirect("mmSessionId", "");
  }, []);

  return (
    <h1
      data-testid="SuccessHeader"
      className="flc_success-header"
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    ></h1>
  );
}
